/*
 * @Description: 国际化语言资源文件
 * @Author: 刘宝顺
 * @Date: 2024-01-15 10:26:30
 * @LastEditTime: 2026-03-16 16:24:20
 * @LastEditors: 刘宝顺
 */
import enUS from './en-US';
import th from './th-TH';
import zh from './zh-CN';
import zhTW from './zh-TW';

const resources = {
    'en-US': {
        translation: enUS,
    },
    'zh-CN': {
        translation: zh,
    },
    'zh': {
        translation: zh,
    },
    'th': {
        translation: th,
    },
    'zh-TW': {
        translation: zhTW,
    },
};

export default resources;
